export const css = {
	root: 'NxyneSjh',
	disabled: 'S0mCVFHb',
	content: 'AfeCUAzT',
	header: 'ORvRaCFf',
	expandedContent: '_1fBtatrx',
	expanded: 'BHYONc7F',
	media: 'Vd0UkYgE',
	visuallyHidden: 'ShVrWx0h',
	promote: 'S9zWLXC8',
	disabledPromote: 'Jd-rKO2j',
	' _key': 'card/card'
};

export default css;
